import styled, { css } from 'styled-components';

import { CardRarity, Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { ScarcityColoredDiv } from '@sorare/core/src/atoms/ui/ScarcityColoredDiv';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import boost from './assets/boost.svg';

const Wrapper = styled.div<{ white: boolean }>`
  display: inline-block;
  height: var(--double-unit);
  width: var(--double-unit);
  aspect-ratio: 1;
  border-radius: 50%;
  overflow: hidden;

  @media ${tabletAndAbove} {
    height: 1em;
    width: 1em;
  }

  ${({ white }) =>
    white
      ? css`
          background-color: var(--c-static-neutral-100);
        `
      : css`
          background-color: var(--c-static-neutral-1000);
        `}
`;

const Icon = styled(ScarcityColoredDiv)<{ highlighted: boolean }>`
  width: 100%;
  height: 100%;

  mask-image: linear-gradient(#fff, #fff), url(${boost});
  mask-repeat: no-repeat;
  mask-size: contain;
  mask-position: center;

  ${({ highlighted }) =>
    highlighted
      ? css`
          /* stylelint-disable-next-line property-no-vendor-prefix */
          -webkit-mask-composite: source-out;
          mask-composite: exclude;
        `
      : css`
          /* stylelint-disable-next-line property-no-vendor-prefix */
          -webkit-mask-composite: source-atop;
          mask-composite: intersect;
        `}
`;

type Props = {
  scarcity: CardRarity | Rarity;
  highlighted?: boolean;
};

export const BoostIcon = ({ scarcity, highlighted }: Props) => {
  return (
    <Wrapper
      white={
        !!highlighted &&
        [
          CardRarity.super_rare,
          CardRarity.unique,
          Rarity.super_rare,
          Rarity.unique,
        ].includes(scarcity)
      }
    >
      <Icon className={scarcity} highlighted={!!highlighted} />
    </Wrapper>
  );
};
